import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './RatingInfo.css';

/**
 * Info popover explaining the Rating 2.0 metric — its components, weights and
 * scale. Toggled by an "ℹ️ Rating?" button; the body copy is translated while
 * technical component names (Kill Rating, KAST, …) stay as-is.
 *
 * @returns {JSX.Element} The toggle button and (when open) the explainer modal.
 */
const RatingInfo = () => {
  const { t } = useTranslation();
  const [showInfo, setShowInfo] = useState(false);

  return (
    <div className="rating-info-container">
      <button
        className="rating-info-button"
        onClick={() => setShowInfo(!showInfo)}
        title={t('rating.buttonTitle')}
      >
        ℹ️ {t('rating.buttonLabel')}
      </button>
      {showInfo && (
        <div className="rating-info-modal">
          <div className="rating-info-content">
            <button className="close-button" onClick={() => setShowInfo(false)}>×</button>
            <h3>📊 Rating 2.0</h3>
            <p className="rating-description">
              {t('rating.descriptionPre')} <strong>1.00</strong>.
            </p>

            <div className="rating-components">
              <h4>{t('rating.componentsHeading')}</h4>
              <div className="component-item">
                <span className="component-name">💀 Kill Rating</span>
                <span className="component-weight">25%</span>
                <span className="component-desc">{t('rating.killRatingDesc')}</span>
              </div>
              <div className="component-item">
                <span className="component-name">🎯 KAST</span>
                <span className="component-weight">20%</span>
                <span className="component-desc">{t('rating.kastDesc')}</span>
              </div>
              <div className="component-item">
                <span className="component-name">🛡️ Survival Rating</span>
                <span className="component-weight">20%</span>
                <span className="component-desc">{t('rating.survivalDesc')}</span>
              </div>
              <div className="component-item">
                <span className="component-name">💥 Damage Rating</span>
                <span className="component-weight">15%</span>
                <span className="component-desc">{t('rating.damageDesc')}</span>
              </div>
              <div className="component-item">
                <span className="component-name">⚡ Impact Rating</span>
                <span className="component-weight">15%</span>
                <span className="component-desc">{t('rating.impactDesc')}</span>
              </div>
              <div className="component-item">
                <span className="component-name">🤝 Assist Bonus</span>
                <span className="component-weight">5%</span>
                <span className="component-desc">{t('rating.assistBonusDesc')}</span>
              </div>
            </div>

            <div className="rating-scale">
              <h4>{t('rating.scaleHeading')}</h4>
              <div className="scale-items">
                <span className="scale-item excellent">1.30+ Excellent</span>
                <span className="scale-item good">1.10+ Good</span>
                <span className="scale-item average">0.90+ Average</span>
                <span className="scale-item below">0.70+ Below avg</span>
                <span className="scale-item poor">&lt;0.70 Poor</span>
              </div>
            </div>

            <p className="rating-note">
              <em>{t('rating.note')}</em>
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default RatingInfo;
